import React, { useEffect, useRef, useState } from "react";
import TeedexFontsComponant from "../../../design/TeedexFontsComponant";
import LocalFontsComponants from "../../../design/LocalFontsComponants";
import {
  changeFontFamilyForAllTextboxes,
  doRequest,
  fontOptions,
} from "../../../utils/helper";
import UploadFonts from "../../../design/UploadFonts";
import { addGlobalFont } from "polotno/config";

export default function CustomeFontChildSection({
  handlePlayerDetail,
  playerDetail,
  // teedexFontsList,
  // setTeedexFontsList,
  selectedObject,
  store,
}) {
  const [teedexFontsList, setTeedexFontsList] = useState([]);
  const [ownFontsList, setOwnFontsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("teedex");
  const [isFontOpen, setIsFontOpen] = useState(false);
  const fontRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFont, setSelectedFont] = useState("");
  const [originalFont, setOriginalFont] = useState(""); // Store the original font
  const [isFirstHover, setIsFirstHover] = useState(true); // Track if this is the first hover after opening
  const [selectedIndex2, setSelectedIndex2] = useState(-1);
  const [selectedIndex3, setSelectedIndex3] = useState(-1);
  const element = store.selectedElements[0];
  const [previewFontSize, setPreviewFontSize] = useState(12);


  // Initialize selectedFont and originalFont when element changes
  useEffect(() => {
    if (element?.fontFamily) {
      setSelectedFont(element.fontFamily);
      setOriginalFont(element.fontFamily);
    }
  }, [element?.fontFamily]);

  // Reset first hover flag when component mounts or tab changes
  useEffect(() => {
    setIsFirstHover(true);
  }, [activeTab]);

  const onMouseEnter = (name) => {
    setIsFontOpen(true);
    // Only apply font preview if it's not the first hover after opening
    if (!isFirstHover) {
      changeFontFamilyForAllTextboxes(name, store);
      element?.canvas?.requestRenderAll();
    }
  };

  const onMouseLeave = () => {
    setIsFontOpen(true);
    // Only restore font if it's not the first hover after opening
    if (!isFirstHover) {
      changeFontFamilyForAllTextboxes(originalFont, store);
      element?.set({ fontFamily: originalFont });
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const getfontsList = async () => {
    try {
      setLoading(true);
      const response = await doRequest("", "GET", "font/list");
      if (+response?.resultFlag === 1) {
        let fonts = response?.response?.font;
        const teedex = fonts.filter((i) => i.uploaded_role === "admin");
        const own = fonts.filter((i) => i.uploaded_role === "user");
        setTeedexFontsList(teedex);
        setOwnFontsList(own);
        loadFonts(fonts); // Load fonts dynamically
        setLoading(false);
      } else {
        setLoading(false);
        setTeedexFontsList([]);
        setOwnFontsList([]);
        alert(response?.message ? response?.message : "Something went wrong");
      }
    } catch (error) {
      setLoading(false);
      alert(error?.message ? error?.message : "Something went wrong!");
    }
  };

  const loadFonts = async (fontsFromApi) => {
    setLoading(true);

    const loadPromises = fontsFromApi.map((font) => {
      const url = font.url.startsWith("http") ? font.url : `/${font.url}`;
      // console.log("Trying to load font:", font.name, "→", url);

      const fontFace = new FontFace(font.name, `url('${url}')`);
      const loadPromise = fontFace
        .load()
        .then((loadedFont) => {
          document.fonts.add(loadedFont);
          // console.log("Font loaded test:", font.name);
        })
        .catch((error) => {
          console.error("❌ Failed to load font:", font.name, error);
        });

      // Inject @font-face
      const format = url.endsWith(".otf")
        ? "opentype"
        : url.endsWith(".ttf")
          ? "truetype"
          : url.endsWith(".woff2")
            ? "woff2"
            : url.endsWith(".woff")
              ? "woff"
              : "";
      const style = document.createElement("style");
      style.innerHTML = `
      @font-face {
        font-family: '${font.name}';
        src: url('${url}') format('${format}');
        font-weight: 400;
        font-style: normal;
        font-display: swap;
      }
    `;
      document.head.appendChild(style);

      // console.log("adding font name: ", font.name, " url: ", font.url);
      addGlobalFont({
        fontFamily: font.name,
        url: `${font.url}`,
      });

      return loadPromise;
    });

    await Promise.all(loadPromises);
    setLoading(false);
  };

  // const loadFonts = async (fonts) => {
  //   setLoading(true);
  //   console.log("fonts", fonts);

  //   const loadPromises = fonts.map((font) => {
  //     const fontFace = new FontFace(font.name, `url(${font.url})`);

  //     // Load the font and add it to the document
  //     const loadPromise = fontFace.load().then((loadedFont) => {
  //       document.fonts.add(loadedFont);
  //     });

  //     // Also add global CSS @font-face rule (if needed)
  //     addGlobalFont({
  //       fontFamily: font.name,
  //       url: `${font.url}`,
  //     });

  //     return loadPromise;
  //   });

  //   // Wait for all fonts to load
  //   await Promise.all(loadPromises);

  //   setLoading(false);
  // };

  useEffect(() => {
    getfontsList();
  }, []);

  const MIN = 8;
  const MAX = 200;
  
  const percent = ((previewFontSize - MIN) / (MAX - MIN)) * 100;
  
  return (
    <>
      <div
        style={{ display: "block" }}
      // className="variation--block__details--container font-name"
      >
        <div className="search-block">
          <input
            type="text"
            placeholder="Search Fonts"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          {searchQuery && (
            <span
              className="clear-icon"
              onClick={() => {
                setSearchQuery(""); // Clear the search query
              }}
            >
              ✖
            </span>
          )}
        </div>



        <div className="font-preview-size-control">
          <span>Preview Size</span>

          <input
            type="range"
            min={MIN}
            max={MAX}
            step={1}
            value={previewFontSize}
            style={{ "--fill-percent": `${percent}%` }}
            onChange={(e) => {
              setPreviewFontSize(Number(e.target.value));
            }}
          />
        </div>

        <div className="tabs">
          <div className="tab-navs">
            <span
              style={{ cursor: "pointer" }}
              onClick={() => setActiveTab("teedex")}
              className={activeTab === "teedex" ? "tab-nav active" : "tab-nav"}
              data-id="teedex-font"
            >
              Teedex Fonts
            </span>
            {/* <span
              style={{ cursor: "pointer" }}
              onClick={() => setActiveTab("local")}
              className={activeTab === "local" ? "tab-nav active" : "tab-nav"}
              data-id="system-font"
            >
              Your System Fonts
            </span> */}
            <span
              style={{ cursor: "pointer" }}
              onClick={() => setActiveTab("upload")}
              className={activeTab === "upload" ? "tab-nav active" : "tab-nav"}
              data-id="system-font"
            >
              Upload Fonts
            </span>
          </div>

          <div
            className={
              activeTab === "teedex" ? "tab-content active" : "tab-content"
            }
          >
            {activeTab === "teedex" && (
              <TeedexFontsComponant
                fontOptions={fontOptions}
                onSelect={handlePlayerDetail}
                selected={playerDetail}
                type="newcomponant"
                teedexFontsList={teedexFontsList}
                setTeedexFontsList={setTeedexFontsList}
                selectedObject={selectedObject}
                searchQuery={searchQuery}
                store={store}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                setSelectedFont={setSelectedFont}
                setOriginalFont={setOriginalFont}
                setIsFirstHover={setIsFirstHover}
                fontsList={teedexFontsList}
                loading={loading}
                previewFontSize={previewFontSize}
              />
            )}
          </div>
          <div
            className={
              activeTab === "local" ? "tab-content active" : "tab-content"
            }
          >
            {activeTab === "local" && (
              <LocalFontsComponants
                onSelect={handlePlayerDetail}
                selected={playerDetail}
                selectedObject={selectedObject}
                type="newcomponant"
                searchQuery={searchQuery}
                store={store}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                setSelectedFont={setSelectedFont}
                setOriginalFont={setOriginalFont}
                setIsFirstHover={setIsFirstHover}
              // onHover={onHover}
              previewFontSize={previewFontSize}
              />
            )}
          </div>
          <div
            className={
              activeTab === "upload" ? "tab-content active" : "tab-content"
            }
          >
            {activeTab === "upload" && (
              <UploadFonts
                store={store}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                setSelectedFont={setSelectedFont}
                setOriginalFont={setOriginalFont}
                setIsFirstHover={setIsFirstHover}
                searchQuery={searchQuery}
                fontList={ownFontsList}
                getAllUploadedFontList={getfontsList}
                loading={loading}
                previewFontSize={previewFontSize}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
